const MIN_WIDTH = 960;
const MIN_HEIGHT = 600;

export const deviceSupported = () => {
  const { width, height } = window.screen;
  return Math.max(width, height) >= MIN_WIDTH
    && Math.min(width, height) >= MIN_HEIGHT;
};

export const browserSupported = () => {
  const ua = window.navigator.userAgent;

  if (ua.indexOf('MSIE') > 0) {
    return false;
  } else if (ua.indexOf('Trident') > 0) {
    return false;
  }

  return true;
};



// WEBPACK FOOTER //
// ./src/utils/browser.js